import { render } from "./CommitModal.vue?vue&type=template&id=2cc0b34f&scoped=true"
import script from "./CommitModal.vue?vue&type=script&lang=js"
export * from "./CommitModal.vue?vue&type=script&lang=js"

import "./CommitModal.vue?vue&type=style&index=0&id=2cc0b34f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc0b34f"]])

export default __exports__